var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('w-select',{attrs:{"model":_vm.schema.statusId,"values":_vm.values}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }